/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AbnormalPaymentResponseDto } from '../../models/abnormal-payment-response-dto';

export interface AbnormalPaymentControllerGetFailedItems$Params {

/**
 * 페이지 번호
 */
  pageNo?: number | null;

/**
 * 페이지 크기
 */
  pageSize?: number | null;

/**
 * 검색어
 */
  query?: string | null;

/**
 * (필터)교사 ID
 */
  filterTeacherId?: string | null;

/**
 * 시작 월
 */
  startMonth: string;

/**
 * 종료 월
 */
  endMonth: string;

/**
 * 교사 ID
 */
  teacherIds: Array<string>;
      body: {
'file'?: Blob;
}
}

export function abnormalPaymentControllerGetFailedItems(http: HttpClient, rootUrl: string, params: AbnormalPaymentControllerGetFailedItems$Params, context?: HttpContext): Observable<StrictHttpResponse<AbnormalPaymentResponseDto>> {
  const rb = new RequestBuilder(rootUrl, abnormalPaymentControllerGetFailedItems.PATH, 'post');
  if (params) {
    rb.query('pageNo', params.pageNo, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('query', params.query, {});
    rb.query('filterTeacherId', params.filterTeacherId, {});
    rb.query('startMonth', params.startMonth, {});
    rb.query('endMonth', params.endMonth, {});
    rb.query('teacherIds', params.teacherIds, {});
    rb.body(params.body, 'multipart/form-data');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AbnormalPaymentResponseDto>;
    })
  );
}

abnormalPaymentControllerGetFailedItems.PATH = '/api/abnormal-payment/failed';
